import { applicationInsights } from '../../../../../../ApplicationInsights';
import { BfiDataGrid, Column } from '@apply/ui';
import { GridSettingType } from '@apply/constants';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { useBrokerBClientsQuery } from '../../../../queries/brokerDetailsQueries';

export const BrokerClientsTable = () => {
    const brokerId = useBrokerDetailsStore((s) => s.brokerId);
    const { data: rows } = useBrokerBClientsQuery(brokerId);

    return (
        <BfiDataGrid
            dataSource={rows ?? []}
            keyExpr='id'
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            noDataText='No B-Client records available'
            defaultPageSize={12}
            allowedPageSizes={[12]}
            applicationInsights={applicationInsights}
            gridType={GridSettingType.BrokerClientsTable}
        >
            <Column
                dataField='personName'
                caption='Person'
                width={200}
                alignment={'left'}
            />
            <Column
                dataField='clientName'
                caption='Business'
                alignment={'left'}
            />
            <Column
                dataField='status'
                caption='Status'
                width={300}
                alignment={'left'}
            />
        </BfiDataGrid>
    );
};
